import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
/* eslint-disable no-sparse-arrays */
import React, { useCallback } from 'react';
import { Edit } from '@material-ui/icons';
import { BLUE, GRAY, Box, Button, Typography, useTheme, Link, IconTooltip } from '@applyboard/ui-components';
import { Card, ProgramTitle, ProgramCardLink } from "./styles";
import ArtsIcon from "./icons/ArtsIcon";
import BusinessIcon from "./icons/BusinessIcon";
import EngineeringIcon from "./icons/EngineeringIcon";
import EnglishIcon from "./icons/EnglishIcon";
import HealthIcon from "./icons/HealthIcon";
import LegalIcon from "./icons/LegalIcon";
import ScienceIcon from "./icons/ScienceIcon";
import { PublishedStatusChip } from "../PublishedStatusChip";
import { InfoOutlineIcon } from '@applyboard/ui-icons';

// This is a mapping of the database "parent" program
// names, which each program should map to.
// TODO: Verify this is actually the case - that they must have a parent program
// Is used to map the program category retrieved from API to a discipline
// enum that can be passed to the ProgramCard.
export var BASE_CATEGORIES_MAP = {
  'Engineering and Technology': 'Engineering',
  Sciences: 'Sciences',
  Arts: 'Arts',
  'Business, Management and Economics': 'Business',
  'Law, Politics, Social, Community Service and Teaching': 'Legal',
  'English for Academic Studies': 'English',
  'Health Sciences, Medicine, Nursing, Paramedic and Kinesiology': 'Health'
};
var ICON_MAPPING = {
  Arts: /*#__PURE__*/React.createElement(ArtsIcon, null),
  Business: /*#__PURE__*/React.createElement(BusinessIcon, null),
  Engineering: /*#__PURE__*/React.createElement(EngineeringIcon, null),
  English: /*#__PURE__*/React.createElement(EnglishIcon, null),
  Health: /*#__PURE__*/React.createElement(HealthIcon, null),
  Legal: /*#__PURE__*/React.createElement(LegalIcon, null),
  Science: /*#__PURE__*/React.createElement(ScienceIcon, null)
};
export function ProgramCard(_ref) {
  var onCheckEligibility = _ref.onCheckEligibility,
    program = _ref.program,
    children = _ref.children,
    onClickCard = _ref.onClickCard,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon;
  var items = [{
    label: 'Earliest intake',
    value: program.earliestIntake
  }, {
    label: 'Deadline',
    value: program.deadline
  }, {
    label: 'Gross tuition',
    value: program.tuition
  }, {
    label: 'Application fee',
    value: program.applicationFee
  }, {
    label: 'Commission',
    value: program.commission
  }].filter(function (_ref2) {
    var value = _ref2.value;
    return !!value;
  });
  var handleCardClick = useCallback(function () {
    onClickCard && onClickCard(program);
  }, [onClickCard, program.id]);
  var onClickEligibilityBtn = useCallback(function () {
    onCheckEligibility && onCheckEligibility(program.id);
  }, [program.id]);
  var preventLinkFromOpening = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Card, {
    "data-testid": "program-card-".concat(program.id),
    breakpoint: theme.breakpoints.values.md
  }, /*#__PURE__*/React.createElement(ProgramCardLink, {
    href: program.links.viewPath,
    target: "_blank",
    onClick: handleCardClick,
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    padding: [0,, 3]
  }, showIcon && /*#__PURE__*/React.createElement(Box, {
    alignSelf: "baseline",
    display: ['none',, 'flex'],
    marginRight: 3
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    bgcolor: BLUE[21],
    borderRadius: "8px",
    display: "flex",
    height: "80px",
    justifyContent: "center",
    width: "80px"
  }, program.discipline && ICON_MAPPING[program.discipline] ? ICON_MAPPING[program.discipline] : /*#__PURE__*/React.createElement(ArtsIcon, null))), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    family: "Montserrat",
    weight: "semibold",
    variant: "h6"
  }, /*#__PURE__*/React.createElement(ProgramTitle, {
    "data-testid": "program-card-".concat(program.id, "-title")
  }, program.name))), /*#__PURE__*/React.createElement(Box, {
    display: ['none',, 'block']
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "secondary",
    variant: "caption"
  }, program.schoolName))), /*#__PURE__*/React.createElement(Box, {
    ml: "auto",
    display: "flex"
  }, /*#__PURE__*/React.createElement(PublishedStatusChip, {
    published: program.published,
    chipProps: {
      mr: 2
    }
  }), program.links.editPath && /*#__PURE__*/React.createElement(Link, {
    href: program.links.editPath,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Edit, {
    color: "secondary"
  })))), /*#__PURE__*/React.createElement(Box, {
    display: [,, 'flex'],
    justifyContent: [,, 'space-between'],
    marginTop: [3,, 2]
  }, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Box, {
      display: ['flex',, null],
      flexDirection: [,, 'column'],
      justifyContent: ['space-between',, 'flex-start'],
      key: idx,
      marginBottom: [idx === items.length - 1 ? 0 : 1,, 0]
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "secondary",
      variant: "caption"
    }, item.label), item.label === 'Commission' ? /*#__PURE__*/React.createElement(IconTooltip, {
      icon: /*#__PURE__*/React.createElement(InfoOutlineIcon, {
        color: "secondary.dark",
        size: "sm"
      }),
      "aria-label": "commission detail",
      title: "IMPORTANT DISCLAIMER/NOTICE: The Commission viewable here is a high-level estimate of what may be receivable by you upon a school confirming successful full-time enrollment. The estimate uses the gross tuition amount posted on the school program page; however, note that the actual Commission you may receive is based on a final determination resulting from ApplyBoard's agreement with the school, the net amount payable to ApplyBoard after deducting ancillary fees, scholarships and/or other non-commissionable fees, and is subject to several variables relevant to each student, such as ESL courses, nationality, the volume of credits/courses, transfer policy (if any), agent change (if any) and the term and/or program. For further specific commission details, consult each student's ApplyBoard application page, specifically the Notes tab.",
      size: "small"
    }) : null), /*#__PURE__*/React.createElement(Typography, {
      color: GRAY[5]
    }, item.label === 'Commission' && item.value && item.value !== 'Unknown' ? "Up to ".concat(item.value) : item.value));
  })), /*#__PURE__*/React.createElement(Box, {
    marginTop: [1, 2],
    onClick: preventLinkFromOpening
  }, children || /*#__PURE__*/React.createElement(Button, {
    onClick: onClickEligibilityBtn,
    variant: "outlined"
  }, "Check Student Eligibility"))))));
}